import LogRocket from 'logrocket';

import { Analytics, AnalyticsPluginType } from '.';

class LogRocketPlugin implements AnalyticsPluginType {
  constructor(logRocketAppId: string) {
    LogRocket.init(logRocketAppId, {
      network: {
        requestSanitizer: (request) => {
          // check for URLs to scrub sensitive request data
          if (
            request.url.toLowerCase().indexOf('okta') !== -1 ||
            (request.body &&
              typeof request.body === 'string' &&
              request.body.toLowerCase().indexOf('password') !== -1)
          ) {
            // clear the body, we don't want logrocket to show password in POST data
            request.body = null;
          }
          return request;
        },
      },
    });
    LogRocket.getSessionURL((sessionUrl) => {
      Analytics.trackEvent('LogRocket', sessionUrl);
    });
  }

  identifyUser(
    userId: string,
    userProperties: Record<string, string | number>
  ) {
    LogRocket.identify(userId);
  }

  isInitialized(): boolean {
    return true;
  }

  resetUser() {
    // LogRocket has no clear way to reset user identity
  }

  trackEvent(category: string, action: string) {
    LogRocket.track(`${category}-${action}`);
  }

  trackPageView(path: string) {
    // LogRocket does not process this event
  }
}

export default LogRocketPlugin;
